module.exports = {
  // purge,
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      borderWidth: {
        "1/16": "0.0625rem",
      },
      borderRadius: {
        2: "2px",
        7: "7px",
      },
      boxShadow: {
        "radio-ring": "0px 0px 0px 2px #FFFFFF, 0px 0px 0px 4px #4467AB",
        "input-ring":
          "0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #4467AB",
        "input-error-ring":
          "0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #EF4444",
        button: "inset 10000px 10000px rgba(0,0,0,0.3)",
        modal:
          "0px 10px 30px rgba(0, 0, 0, 0.19), 0px 6px 10px rgba(0, 0, 0, 0.23)",
      },
      borderColor: {
        button: "rgba(0, 0, 0, 0.05)",
      },
      colors: {
        // blues
        "text-blue": "#182A44",
        "brand-blue": "#2C405A",
        "deep-blue": "#2D5495",
        "action-blue": "#4467AB",
        "light-border-blue": "#D8E5EE",
        "medium-border-blue": "#b7d2e5cc",
        "dark-border-blue": "#C7D8E8",
        "dark-fill-blue": "#E5EEF5",
        "medium-fill-blue": "#ECF5FD",
        "light-fill-blue": "#F1F6FA",
        // greys
        "dark-grey": "#525F73",
        "medium-grey": "#808D9E",
        "dark-border-grey": "#D1D5DB",
        "dark-fill-grey": "#E5E7EB",
        "medium-fill-grey": "#F6F6F6",
        "light-fill-grey": "#F9F9F9",
        "light-border-grey": "#FAFBFC",
        "light-medium-grey": "#58606e",
        white: "#FFFFFF",
        // colors
        red: "#D0021B",
        "light-red": "#FF9494",
        "dark-red": "#991B1B",
        orange: "#DA6625",
        yellow: "#F4D316",
        "light-yellow": "#FFFAEB",
        green: "#4ECE3D",
        "light-green": "#E7F3E5",
        "dark-green": "#078B00",
        purple: "#712F79",
        // blues
        "dark-blue": "#182A44", // replaced by 'text-blue'
        "action-light-blue": "#52B4FF",
        "action-darker-blue": "#105890",
        "light-pale-blue": "#ECF5FD", // replaced by 'medium-fill-blue'
        "pale-blue": "#F1F6FA", // replaced by 'light-fill-blue'
        "med-pale-blue": "#E3EBF3",
        "dark-pale-blue": "#C7D8E8", // replaced by 'dark-border-blue'
        "gray-blue": "#808D9E", // replaced by 'medium-grey'
        "current-med-blue": "#5E91F7",
        "blue-border": "#C7D8E8", // replaced by 'dark-border-blue'
        "united-blue": "#4571BA",
        "focus-blue": "#005FCC",
        // greys
        grey: "#525F73", // replaced by 'dark-grey'
        "white-grey": "#FAFBFC", // replaced by 'light-border-grey'
        "light-grey": "#F6F6F6", // replaced by 'medium-fill-grey'
        "lighter-grey": "#F9F9F9", // replaced by 'light-fill-grey'
        "gray-light": "#FAFBFC", // replaced by 'light-border-grey'
        "grey-500": "#525F73", // replaced by 'dark-grey'
        "border-grey": "#D1D5DB", // replaced by 'dark-border-grey'
        "pale-grey": "#D8E5EE", // replaced by 'light-border-blue'
        "light-pale-grey": "#E5EEF5", // replaced by 'dark-fill-blue'
        "silver-color": "#CACACA",
        // greens
        "pale-green": "#E7F3E5", // replaced by 'light-green'
        // reds
        "validation-red": "#D0021B", // replaced by 'red'
        "medium-yellow": "#F7C83B",
        // others
        "light-purple": "#EAA1F2",

        "table-border-color": "#b7d2e5", // replaced by 'medium-border-blue'
      },
      fontFamily: {
        "regular-font":
          '"Proxima Nova", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        "medium-font":
          '"Proxima Nova Medium", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        "heavy-font":
          '"Proxima Nova Heavy", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      },
      fontSize: {
        "13px": "13px",
        "15px": "1.071rem",
        "22px": "22px",
      },
      flex: {
        2: "0 1 30px",
        3: "0 0 40px",
        4: "1 1 auto",
      },
      gridTemplateColumns: {
        "line-items":
          "minmax(min-content, max-content) minmax(min-content, 1fr)",
      },
      height: {
        1.5: "0.375rem",
        9: "2.25rem",
        14: "3.5rem",
        36: "9rem",
        60: "60px",
        "38px": "38px",
        "175px": "175px",
        "700px": "700px",
      },
      lineHeight: {
        2: "0.813rem",
        7.5: "1.875rem",
      },
      maxHeight: {
        80: "20rem",
        "300px": "300px",
        "90vh": "90vh",
      },
      minHeight: {
        "50px": "50px",
        "100px": "100px",
      },
      inset: {
        46: "46px",
        4: "1rem",
        60: "60px",
        "1/2": "50%",
        "2/10": "20%",
        "-500": "-500%",
      },
      margin: {
        0.5: "0.125rem",
        0.75: "0.1875rem",
        1.5: "0.375rem",
        2.5: "0.625rem",
        9: "2.25rem",
        "-container-padding": "-15px",
        "0.75em": "0.75em",
        15: "3.75rem",
        "-3px": "-3px",
        "-15px": "-15px",
        "-1px": "-1px",
        "-28": "-7rem",
        "15px": "15px",
      },
      outline: {
        solid: ["1px solid #4467ab"],
        "solid-offset": ["1px solid #005FCC", "2px"],
      },
      opacity: {
        40: "0.4",
        80: "0.8",
      },
      padding: {
        1.2: "0.313rem",
        1.5: "0.375rem",
        2.5: "0.625rem",
        9: "2.25rem",
        15: "15px",
        "20px": "20px",
        "21px": "21px",
      },
      width: {
        0.5: "0.125rem",
        1.5: "0.375rem",
        7: "1.75rem",
        9: "2.25rem",
        11: "60px",
        60: "15.625rem",
        80: "20rem",
        100: "25rem",
        600: "600px",
        275: "275px",
        400: "400px",
        800: "800px",
        1000: "1000px",
        "9/10": "90%",
      },
      maxWidth: {
        "9/10": "90%",
      },
      minWidth: {
        24: "1.5rem",
        "400px": "400px",
      },
      zIndex: {
        1: "1",
        dropdown: "103",
        drawer: "104",
        appbar: "105",
        modal: "107",
        1400: "1400",
        1500: "1500",
        "-100": "-100",
      },
      translate: {
        "200px": "200px",
      },
    },
  },
  variants: {
    borderColor: [
      "responsive",
      "hover",
      "focus",
      "focus-within",
      "checked",
      "group-hover",
    ],
    backgroundColor: [
      "responsive",
      "hover",
      "focus",
      "focus-within",
      "checked",
      "group-hover",
    ],
    boxShadow: ["responsive", "hover", "focus", "focus-within"],
    opacity: ["disabled", "hover"],
  },
  corePlugins: {
    container: false,
  },
  plugins: [],
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
};
